import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerGrid}>
          {/* Company Info */}
          <div className={styles.footerSection}>
            <Link to="/" className={styles.footerLogo}>LUCQA</Link>
            <p className={styles.companyDesc}>
              Transformando ideas en soluciones digitales innovadoras para impulsar tu negocio hacia el futuro.
            </p>
            <div className={styles.socialLinks}>
              <a href="https://github.com/lucqa" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <FaGithub />
              </a>
              <a href="https://linkedin.com/company/lucqa" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <FaLinkedin />
              </a>
              <a href="https://twitter.com/lucqa" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                <FaTwitter />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          {/* Company Links */}
          <div className={styles.footerSection}>
            <h3>Compañía</h3>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/nosotros" className={styles.specialLink}>
                  <span className={styles.linkText}>Nosotros</span>
                  <span className={styles.linkDecoration}></span>
                </Link>
              </li>
              <li>
                <Link to="/terminos" className={styles.specialLink}>
                  <span className={styles.linkText}>Términos y Condiciones</span>
                  <span className={styles.linkDecoration}></span>
                </Link>
              </li>
              <li>
                <Link to="/blog" className={styles.specialLink}>
                  <span className={styles.linkText}>Blog</span>
                  <span className={styles.linkDecoration}></span>
                </Link>
              </li>
              <li>
                <Link to="/reclamaciones" className={styles.specialLink}>
                  <span className={styles.linkText}>Libro de Reclamaciones</span>
                  <span className={styles.linkDecoration}></span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className={styles.footerSection}>
            <h3>Servicios</h3>
            <ul className={styles.footerLinks}>
              <li><Link to="/servicios">Desarrollo Web</Link></li>
              <li><Link to="/servicios">Apps Móviles</Link></li>
              <li><Link to="/servicios">Automatización</Link></li>
              <li><Link to="/servicios">DevOps</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className={styles.footerSection}>
            <h3>Contacto</h3>
            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <FaMapMarkerAlt />
                <span>Lima - Perú</span>
              </div>
              <div className={styles.contactItem}>
                <FaPhone />
                <span>969 610 514</span>
              </div>
              <div className={styles.contactItem}>
                <FaEnvelope />
                <span>contacto@lucqa.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            © {new Date().getFullYear()} LUCQA. Todos los derechos reservados.
          </div>
          <div className={styles.footerBottomLinks}>
            <Link to="/privacidad">Privacidad</Link>
            <Link to="/terminos">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;